import type { Change } from './change'
import type { Data } from './data'
import type { Node } from './node'

export interface OrgChart extends Data {
  edits: Partial<Record<Node.Id, Node>>
  currentlyEditingNodeId?: Node.Id
  history: readonly Change[]
  /**
   * How many undos have been applied against the current {@link history}
   */
  undoCount: number
}
export namespace OrgChart {
  export type Id = keyof Lookup
  export namespace Id {
    export const ALL = ['current', 'proposed'] as const satisfies readonly Id[]
    /**
     * __NOTE:__ this type only exists as a validation check. If this has an
     * error, we are missing an ID above
     */
    type EnsureWeHaveAllIds = Satisfies<Id, (typeof ALL)[number]>
  }

  export interface Identifier {
    readonly orgChartId: Id
  }

  export interface Lookup {
    readonly current: OrgChart
    readonly proposed?: OrgChart
  }
}
